export default __webpack_public_path__ + "static/media/icon-back.b3e9a9f4.svg";